import { controls } from "../controls";

const dashboard1 = {
  label: "Home",
  pageLabel: "Dashboard",
  starting: true,
  url: "home",
  pageType: "history",
  visitingBranches: true,
  dashboard: [
    ...controls.dashboardsGenerator({ sequence: 4 })
  ],
  history: {
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" }
  }
};

export default dashboard1;